/**
 * @module Section-Home1-What-We-Do
 */

import { SECTION_THEME } from "../../../../globals/constants";
import { TypeSectionWhatWeDo } from "../../../@types/sectionTypes";
import AvertImage from "../../../../globals/elements/avertimg";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger, SplitText } from "gsap/all";
import { useRef } from "react";
gsap.registerPlugin(ScrollTrigger, SplitText);
/**
 * 
 * @param props Data supplied to display our working
 * @returns Markup for section showing our working style
 */
const SectionHome1WhatWeDo = (
    props: {
        _whatWeDo: TypeSectionWhatWeDo
        _background?: SECTION_THEME
    }
) => {

    const { _whatWeDo, _background } = props;

    // section style white (default)
    var _sectionStyle = "p-t0 site-bg-white av-whatwe-section-wrap";

    // section style gray
    if (_background && _background === SECTION_THEME.DARK) {
        _sectionStyle = "p-t120 site-bg-gray av-whatwe2-section-wrap";
    }
 const container = useRef<HTMLDivElement | null>(null);

  useGSAP(
    () => {
    //   let split = SplitText.create(".about_para_animation", {
    //     type: "lines",
    //   });
 
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top+=250 bottom",
          end: "bottom",
        //   markers: true
        },
      });
    //   tl.fromTo(
    //     ".reveal",
    //     { scale: 0.8, opacity: 0 },
    //     { scale: 1, duration: 1, opacity: 1 },
    //   )

tl.fromTo(
          ".whatwe_heading_animation",
          { opacity: 0, y: 60 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.1,
          }, "0"
        ).fromTo(
          ".whatwe_image_animation",
          { opacity: 0, y: 100 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
          }, "0"
        )
        .fromTo(
          ".whatwe_para_animation",
          { opacity: 0, y: 40 },
          {
            opacity: 1,
            y: 0,
            duration: 1,
            stagger: 0.1,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }, "0.4"
        )
      return () => {
        tl.kill();
      };
    },
    { scope: container },
  );
    return (
        <div className={"section-full " + _sectionStyle + " wow fadeInDown"} data-wow-offset={100} data-wow-delay="0.2">
            <div className="container">
                <div className="section-content" ref={container}>
                    <div className="row">
                        <div className="col-lg-6 col-md-12 m-b30">
                            <div className="av-content-title">
                                <div className="av-sm-title whatwe_heading_animation">{_whatWeDo.title}</div>
                                <h2 className="av-large-title whatwe_heading_animation">{_whatWeDo.subtitle}</h2>
                                <div className="whatwe_para_animation" dangerouslySetInnerHTML={
                                    { __html: _whatWeDo.description }
                                }></div>
                                {/* <div className="av-list2">
                                    <ul>
                                        {
                                            _whatWeDo.features.map((_item, _index) => {
                                                return (
                                                    <li key={_index}>{_item.title}</li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 m-b30">
                            <div className="av-image-collage">
                                <div className="av-media-1 whatwe_image_animation">
                                    <AvertImage src={_whatWeDo.image1} alt="#" />
                                </div>
                                <div className="av-media-2 whatwe_image_animation">
                                    <AvertImage src={_whatWeDo.image2} alt="#" />
                                </div>
                                {/* <div className="pie-wrap">
                                    <svg viewBox="0 0 64 64" className="pie">
                                        <circle r="25%" cx="50%" cy="50%" style={{ strokeDasharray: '19.3 100' }} />
                                        <circle id="pinky" r="25%" cx="50%" cy="50%" style={{ strokeDasharray: '56.3 100', strokeDashoffset: '-19.3' }}>
                                        </circle>
                                    </svg>
                                    <div className="pie-content">
                                        <h3 className="av-title">{_whatWeDo.delivery}</h3>
                                        <p>Deliver</p>
                                    </div>
                                </div> */}
                                {/* {
                                    _whatWeDo.video &&
                                    <a href={_whatWeDo.video!} className="mfp-video ac-text-circle-btn">
                                        <i className="fa fa-play" />
                                        <AvertImage className="spinner-object" src="images/icon/ic-3.png" alt="text" />
                                    </a>
                                } */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SectionHome1WhatWeDo;